"use strict";

let constval = 
    {
        // ページ遷移時の連打制御数値
        "pageControl":500,

        // 手入力の企業ID
        "MANUAL_CORPORATION_ID" : "0",

        // AJAX通信のタイムアウト時間(ms) 0はタイムアウト無効
        "AJAX_TIMEOUT": {
            "MS": 60000,
            "NONE": 0
        }
    }
module.exports = constval;
